import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import { Field, ErrorMessage } from "formik";
import Switch from "react-switch";



const RavenFormikRadioButtonComp = ({
  name,
  label,
  divClassName,
  disabled,
  checked,
  onChange,
  onColor,
  onHandleColor,
  uncheckedIcon,
  checkedIcon,
  height,
  width,
  handleDiameter,
}) => {
  return (
    <div id={name + "_div"} className={divClassName || "mb-3"}>
      <Label className="form-label">{label}</Label>
      <div name={name} id={name} className="is-invalid">
        <Switch
          checked={checked}
          onChange={onChange}
          onColor={(onColor ? { onColor: onColor } : undefined)}
          onHandleColor={onHandleColor}
          handleDiameter={(handleDiameter ? { handleDiameter: handleDiameter } : 20)}
          uncheckedIcon={(uncheckedIcon ? { uncheckedIcon: uncheckedIcon } : undefined)}
          checkedIcon={(checkedIcon ? { checkedIcon: checkedIcon } : undefined)}
          boxShadow="0px 1px 5px rgba(0, 255, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={(height ? { height: height } : 22)}
          width={(width ? { width: width } : 45)}
          className="react-switch"
          id="material-switch"
          disabled={disabled}
        />
      </div>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

RavenFormikRadioButtonComp.propTypes = {
  name: PropTypes.any,
  label: PropTypes.any,
  divClassName: PropTypes.any,
  disabled: PropTypes.bool,
  checked: PropTypes.any,
  onChange: PropTypes.any,
  handleOnChange: PropTypes.any,
  onColor: PropTypes.any,
  onHandleColor: PropTypes.any,
  uncheckedIcon: PropTypes.any,
  checkedIcon: PropTypes.any,
  height: PropTypes.any,
  width: PropTypes.any,
  handleDiameter: PropTypes.any,
};

export default RavenFormikRadioButtonComp;
